import {
  SectionElement,
  defineElement,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-wimmelbild/shop-wimmelbild.ts
var ShopWimmelbild = class extends SectionElement {
  connectedCallback() {
    var _a;
    (_a = this.scrollView) == null ? void 0 : _a.scrollTo({ left: window.innerWidth });
    setTimeout(() => {
      var _a2;
      return (_a2 = this.scrollView) == null ? void 0 : _a2.addEventListener("scroll", this.onSwipe.bind(this));
    }, 300);
    if (this.popupButtons) {
      for (const popupButton of this.popupButtons) {
        popupButton.addEventListener("click", this.hidePopup.bind(this));
      }
    }
    if (this.clickableItems) {
      for (const item of this.clickableItems) {
        item.addEventListener("click", this.itemClicked.bind(this));
      }
    }
  }
  onSwipe() {
    this.classList.add("swiped");
  }
  hidePopup(event) {
    const button = event.target;
    const popupCard = button.closest(".bx-popup-card");
    const popupContainer = button.closest(".bx-popups-container");
    popupCard == null ? void 0 : popupCard.remove();
    this.classList.add("active");
    if ((popupContainer == null ? void 0 : popupContainer.children.length) === 0)
      popupContainer.remove();
  }
  itemClicked(event) {
    const item = event.target;
    const url = item.dataset.click;
    if (url !== void 0)
      window.location.href = url;
  }
};
__decorateClass([
  query(".bx-wimmelbild-wrapper")
], ShopWimmelbild.prototype, "scrollView", 2);
__decorateClass([
  query(".bx-swipe-gesture-icon")
], ShopWimmelbild.prototype, "swipeIcon", 2);
__decorateClass([
  queryAll(".bx-popup-card *[data-close]")
], ShopWimmelbild.prototype, "popupButtons", 2);
__decorateClass([
  queryAll(".bx-clickable-item")
], ShopWimmelbild.prototype, "clickableItems", 2);
ShopWimmelbild = __decorateClass([
  defineElement("shop-wimmelbild")
], ShopWimmelbild);
export {
  ShopWimmelbild
};
